import { Referent } from "./referent";
import { Ruche } from "./ruche";

export class Rucher {
    id_rucher: string = '-1';
    ville: string;
    lieu: string;
    code: string;
    refRole: string;
    referents: Referent[] = [];
    ruches: Ruche[] = [];

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/rucher.ts